module.exports = __webpack_public_path__ + "media/img/illustrations/star-da3cbf2106749e45c9a9efd198a54ff0.svg";